<div class="row d-flex justify-content-end container-style px-2 py-1">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
      (onClick)="createNewRegister()" [severity]="'success'" [width]="'5rem'" [variant]="undefined">
    </app-custom-button>
    <app-custom-modal #registerPurchaseProjectionModal [header]="'Captura Proyección Compra'" [width]="'50vw'"
      [output$]="output$" [inputs$]="inputsForRegisterModals$" [children]="componentRegisterPurchaseProjection" hidden>
    </app-custom-modal>
  </div>
</div>
@if (!isOpened) {
<div class="container-style mt-2">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="url" (onRecoverData)="getAllPurchaseProjectionsWithPagination()"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>
} @else {
<div class="container-form d-flex flex-row text-danger">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
}